import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BuyElectricityTransactionState {
	reference: string | null;
	paymentType: "prepaid" | "postpaid" | null;
	amount: string | null;
	fee: number | null;
	meterNumber: string | null;
	utilityId: string | null;
	timestamp: number | null;
	paymentMethod: string | null;

	status: "failed" | "pending" | null;
	date: string | null;
	time: string | null;
}

const initialState: BuyElectricityTransactionState = {
	reference: null,
	paymentType: null,
	amount: null,
	fee: null,
	meterNumber: null,
	utilityId: null,
	timestamp: null,
	paymentMethod: null,

	status: null,
	date: null,
	time: null,
};

const currentBuyElectricityTransactionSlice = createSlice({
	name: "currentBuyElectricityTransaction",
	initialState,
	reducers: {
		setTransactionPaymentType: (state, action: PayloadAction<"prepaid" | "postpaid">) => {
			state.paymentType = action.payload;
			state.timestamp = Date.now();
		},

		setTransactionDetails: (
			state,
			action: PayloadAction<{
				amount: string;
				meterNumber: string;
				utilityId: string;
				fee?: number;
			}>
		) => {
			state.amount = action.payload.amount;
			state.meterNumber = action.payload.meterNumber;
			state.utilityId = action.payload.utilityId;
			state.fee = action.payload.fee ?? null;
			state.timestamp = Date.now();
		},

		setTransactionReference: (state, action: PayloadAction<string>) => {
			state.reference = action.payload;
			state.timestamp = Date.now();
		},

		setPaymentMethod: (state, action: PayloadAction<string>) => {
			state.paymentMethod = action.payload;
			state.timestamp = Date.now();
		},

        setTransactionStatus: (state, action: PayloadAction<'failed' | 'pending'>) => {
      state.status = action.payload;
      const now = new Date();
      state.date = now.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        year: 'numeric' 
      });
      state.time = now.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true 
      });
      state.timestamp = Date.now();
    },

		updateTransaction: (state, action: PayloadAction<Partial<BuyElectricityTransactionState>>) => {
			return {
				...state,
				...action.payload,
				timestamp: Date.now(),
			};
		},

		clearTransaction: state => {
			return initialState;
		},
	},
});

export const { setTransactionPaymentType,
    setTransactionDetails,
    setTransactionReference,
    setPaymentMethod,
    updateTransaction,
    setTransactionStatus,
    clearTransaction 
   } = currentBuyElectricityTransactionSlice.actions;

export default currentBuyElectricityTransactionSlice.reducer;
